/**
 *  FullComposition.js
 *  This component created to compose pdf-viewer's layout
 *
 *  PDFAnno.js
 *  This is the main viewer component
 *
 *  we keep in FullComposition the state of the viewer and pass the props to PDFAnno component
 *
 *  in the render()
 *  we have the instance of PDFAnno component and have an access to it's functionality:
 *  <PDFAnno>
 *    {viewer => {
 *          .... feel free to compose the structure of view
 *          viewer.renderMainView() - has to be here, because this is the render of the pdf-viewer and annotation layer
 *      }
 *    }
 *   </PDFAnno>
 *
 * ThumbnailsListView.js
 * This is a thumbnails component. Check its props to understand what do you need to pass to him.
 *
 *
 * CommentsList.js
 * This is a comments component. Check its props to understand what do you need to pass to him.
 *
 */

import React, { Fragment } from 'react';
// import PDFJSAnnotate from '../../../../node_modules/pdf-annotate.js/dist/pdf-annotate';
import PropTypes from 'prop-types';
import { CirclePicker /*, ChromePicker*/ } from 'react-color';
// import PDFViewer, { MainLayer, CommentsList, ThumbnailsListView } from './src';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { constants } from './src';

import PDFAnno from './src/PDFAnno';

import { Icons } from './src';
import ThumbnailsListView from './src/ThumbnailsListView';
import CommentsList from './src/CommentsList';
import store from '../../../stores/store';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

let { /*HIGHLIGHT_TOOL, PEN_TOOL, POINT_TOOL, */ pickerColors, pickerHighlightColors } = constants;

let {
    Close,
    ZoomOut,
    ZoomIn,
    TogglerThumbs,
    ToggleComments,
    Rotate,
    Print,
    PageNext,
    PagePrev,
    NoteYellow,
    Highlight,
    EraseNotes,
    Draw,
    Download,
    Notes,
    Undo,
    ColorSelectionDropdown,
} = Icons;

let fs
let dialog
let shell
if (window.require) {
    fs = window.require('fs')
    let remote = window.require('electron').remote
    dialog = remote.dialog
    shell = remote.shell
}

export default class FullComposition extends React.Component {
    constructor() {
        super();
        this.interval = null;
        this.state = {
            docHistoryDropdownOpen: false,
            showColorPicker: false,
            showColorPickerHighlight: false,
            showThumbsPanel: false,
            showCommentPanel: false,
            scale: 1,
            page: 1,
            rotate: 0,
            penColor: 'black',
            highlightColor: 'rgba(255,255,0, 0.3)',
        };
    }

    componentDidMount() {
        // registering listener function to get key pressing events
        window.addEventListener('keydown', this.documentOnKeyDown);
    }

    componentWillUnmount() {
        // unregistering listener function to avoid multi execution
        window.removeEventListener('keydown', this.documentOnKeyDown);
    }

    onClickPrevious = item => {
        if (this.props.onClickPrevious) this.props.onClickPrevious(item);
    };

    /**
     * listen key pressing events
     * @param e
     */
    documentOnKeyDown = e => {
        if (e.keyCode === 38 || e.keyCode === 37) {
            this.prevPage();
        }

        if (e.keyCode === 40 || e.keyCode === 39) {
            this.nextPage();
        }
    };

    getNameById(id) {
        switch (id) {
            case 2:
                return 'Governance';
            case 6:
                return 'Agenda';
            default:
                return 'Votes';
        }
    }

    onCloseButton = () => {
        this.reloadContent();
        if (this.props.onClose) this.props.onClose();
    };

    reloadContent = async () => {
        if (await store.conn.checkOnlineStatus()) {
            //store.meetings.fetch();
            store.meetings.fetchCurrentGroup();
        }
    };
    colorPickerToggle = () => {
        this.setState({ showColorPicker: !this.state.showColorPicker });
    };

    colorPickerHightlightToggle = () => {
        this.setState({ showColorPickerHighlight: !this.state.showColorPickerHighlight });
    };

    getPreviousDocs = () => {
        let previousDocs = this.props.previousDocs;
        if (previousDocs) {
            return (
                <DropdownMenu>
                    <div className="recent-label text-muted">Recent</div>
                    {previousDocs.reverse().map((item, i) => {
                        return (
                            <DropdownItem key={i} onClick={this.onClickPrevious.bind(this, item)}>
                                <div>
                                    {item.fileName}
                                    <div style={{ fontSize: '0.8rem', color: 'lightgrey' }}>
                                        {this.getNameById(item.docTypeId)}
                                    </div>
                                </div>
                            </DropdownItem>
                        );
                    })}
                </DropdownMenu>
            );
        }
    };

    /**
     * color selected
     * @param color
     */
    handleChangeComplete = color => {
        if (this.props.onChangeDrawingColor) this.props.onChangeDrawingColor(color.hex);
        this.setState({ showColorPicker: false });
    };

    toggleHistoryDropdown = () => {
        this.setState({
            docHistoryDropdownOpen: !this.state.docHistoryDropdownOpen,
        });
    };

    /**
     *  On/Off the toggle panel
     */
    toggleCommentPanel = () => {
        this.setState({ showCommentPanel: !this.state.showCommentPanel });
    };

    /**
     *  On/Off the Thumbnails panel
     */
    toggleThumbsPanel = () => {
        this.setState({ showThumbsPanel: !this.state.showThumbsPanel });
    };

    /**
     * listen for key pressing in page number input
     * @param viewer
     * @param e
     */
    pageInputKeyUp = (viewer, e) => {
        if (e.keyCode === 27 || e.keyCode === 13) {
            // Enter
            e.target.value = this.state.page;
        }
    };

    /**
     * leaving the input
     * @param viewer
     * @param e
     */
    pageInputOnBlur = (viewer, e) => {
        e.target.value = this.state.page;
    };

    /**
     * page have changed
     * @param viewer
     * @param e
     */
    onPageChange = (viewer, e) => {
        let value = e.target.value;
        if (value === '') return;
        let pageNumber = Number(value);
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setTimeout(() => {
            // wait a bit
            if (typeof pageNumber === 'number' && pageNumber === parseInt(pageNumber, 10)) {
                if (pageNumber > 0 && pageNumber <= viewer.state.pages) {
                    this.setState({ page: pageNumber });
                } else {
                    this.pageInput.value = this.state.page;
                }
            }
            this.interval = null;
        }, 100);
    };

    /**
     *  on focus page input
     * @param event
     */
    handleFocus = event => {
        event.target.select();
    };

    zoomIn = () => {
        if (this.state.scale < 2) {
            this.setState({ scale: Math.round10(this.state.scale + 0.2, -2) });
        }
    };

    zoomOut = () => {
        if (this.state.scale > 0.4) {
            this.setState({ scale: Math.round10(this.state.scale - 0.2, -2) });
        }
    };

    prevPage = () => {
        if (this.state.page > 1) {
            this.pageInput.value = this.state.page - 1;
            this.setState({ page: this.state.page - 1 });
        }
    };

    nextPage = () => {
        let pages = this.pdf && this.pdf.state.pages;
        if (this.state.page !== pages) {
            this.pageInput.value = this.state.page + 1;
            this.setState({ page: this.state.page + 1 });
        }
    };

    rotate = () => {
        this.pdf.changeCurrentTool(null);
        this.setState({ rotate: this.state.rotate + 90 });
    };

    onChangeAnnotations = annotations => {
        // console.log('App onChangeAnnotations', annotations);
        store.documents
            .updateAnnotations(annotations)
            .then(res => {
                // console.log('updateAnnotations', res)
            })
            .catch(e => {
                console.log('updateAnnotations error ', e);
            });
    };

    /**
     * passing to viewer
     */
    undo = () => {
        if (this.pdf) this.pdf.undo();
    };

    /**
     * passing to viewer
     */
    redo = () => {
        if (this.pdf) this.pdf.redo();
    };

    /**
     * changing drawing color
     * @param hex
     */
    onChangeDrawingColor = hex => {
        this.setState({ penColor: hex });
    };

    /**
     * changing highlight color
     * @param hex
     */
    onChangeHighlightColor = hex => {
        this.setState({ highlightColor: hex });
    };

    /**
     * change the page when a comment was clicked
     * @param item
     */
    onClickComment = item => {
        this.pageInput.value = item.page;

        this.setState({ page: item.page }, () => {
            if (this.pdf) {
                this.pdf.selectItem(item);
            }
        });
    };

    onSelectPage = page => {
        this.pageInput.value = page;
        this.setState({ page });
    };

    /**
     * getting comments from annotations
     * @param annotations
     */
    getComments = annotations => {
        // console.log('FullComposition getComments', annotations);
        return annotations.filter(item => {
            return item.type === 'comment';
        });
    };

    /**
     * this is for back compatibility of old version of the notes (drawings)
     * @param lines
     * @returns {string}
     */
    createPathFromLines = lines => {
        // console.log('---lines', lines);
        let path = 'M ';
        lines.forEach((item, i) => {
            if (i === 0) {
                path += item[0] + ' ' + item[1];
            } else {
                let dX = item[0] - lines[i - 1][0];
                let dY = item[1] - lines[i - 1][1];
                path += ' l ' + dX + ' ' + dY;
            }
        });
        return path;
    };

    /**
     * this is for back compatibility of old version of the notes
     * @param annotations
     * @returns {*}
     */
    annotationAdapter = annotations => {
        if (!annotations) return [];
        let newAnnotations = [];
        // get points and comments
        annotations.forEach(item => {
            let newItem = {};
            if (item.type === 'point') {
                let content = annotations.filter(i => i.annotation === item.uuid)[0].content;

                newItem.x = item.x;
                newItem.y = item.y;
                newItem.uuid = item.uuid;
                newItem.page = item.page;
                newItem.type = 'comment';
                newItem.content = content;
            } else if (item.type === 'drawing') {
                newItem.uuid = item.uuid;
                newItem.type = 'path';
                newItem.stroke = item.color;
                newItem.page = item.page;
                newItem.data = this.createPathFromLines(item.lines);
                newItem.strokeWidth = item.width;
            } else if (item.type === 'highlight') {
                let minX,
                    minY,
                    width = 0,
                    height = 0;
                item.rectangles.forEach(rect => {
                    if (!minX || (minX && rect.x < minX)) {
                        minX = rect.x;
                    }
                    if (!minY || (minY && rect.y < minY)) {
                        minY = rect.y;
                    }
                    let difX = minX ? rect.x - minX : 0;
                    // console.log('difX ', difX);
                    if (!width || (width && width + difX > width)) {
                        width = rect.width + difX;
                    }
                    let difY = minY ? rect.y - minY : 0;
                    // console.log('difY ', difY);
                    if (!height || (height && height + difY > height)) {
                        height = rect.height + difY;
                    }
                });

                newItem.uuid = item.uuid;
                newItem.type = 'area';
                newItem.fill = 'rgba(255,255,0, 0.3)';
                newItem.page = item.page;
                newItem.x = minX;
                newItem.y = minY;
                newItem.width = width;
                newItem.height = height;
            } else {
                newItem = item;
            }
            // console.log('newItem ', newItem);
            newAnnotations.push(newItem);
        });
        return newAnnotations.filter(i => i.type);
    };

    download() {
        if (fs && dialog) {
            const savedFilePath = dialog.showSaveDialog(null, { defaultPath: this.props.fileName + ".pdf" })
            if (savedFilePath != null) {
                fs.writeFile(savedFilePath, this.props.viewableDocumentBytes, (err) => {
                    store.conn.isOnline ? store.documents.syncSharing(store.documents.getCurrentParmasForSharing()) : store.documents.saveSharing()
                })
            }
        }
    }

    render() {
        let {
            fileName,
            showNotes,
            showRotation,
            showDownload,
            annotations
        } = this.props;

        return (
            <PDFAnno
                blob={this.props.blob}
                scale={this.state.scale}
                page={this.state.page}
                rotate={this.state.rotate}
                ref={el => (this.pdf = el)}
                onChangeAnnotations={this.onChangeAnnotations}
                className="btp-pdf-viewer fullscreen"
                penColor={this.state.penColor}
                highlightColor={this.state.highlightColor}
                annotations={this.annotationAdapter(annotations)}
                currentTool={0}
                fileName={this.props.fileName}
            >
                {viewer => {
                    let historyLength = viewer.state.history.length;
                    // console.log('FullComposition viewer state', viewer.state)
                    return (
                        <Fragment>
                            <div className="my-toolbar sticky-top" id="pdf-viewer-toolbar">
                                <div>
                                    <Dropdown
                                        className="file-name-dropdown my-toolbar-left"
                                        isOpen={this.state.docHistoryDropdownOpen}
                                        toggle={this.toggleHistoryDropdown}
                                    >
                                        <DropdownToggle caret>
                                            <span className="file-name">{fileName}</span>
                                        </DropdownToggle>
                                        {this.getPreviousDocs()}
                                    </Dropdown>
                                </div>
                                <div className="my-toolbar-middle">
                                    {showNotes && (
                                        <button
                                            className={`btp-pdf-viewer-buttons toolbar-btn ${
                                                viewer.state.currentTool === 2 ? 'active' : ''
                                                }`}
                                            title="Drawing"
                                            onClick={viewer.changeCurrentTool}
                                            type="button"
                                            data-type="pen"
                                            disabled={this.state.rotate % 360 !== 0}
                                        >
                                            <Draw />
                                        </button>
                                    )}
                                    {showNotes && (
                                        <div className="btp-pdf-viewer-buttons colorpicker">
                                            <ColorSelectionDropdown
                                                className=""
                                                title="Colour picker"
                                                color={this.state.penColor}
                                                onClick={this.colorPickerToggle.bind(this)}
                                            />
                                            {this.state.showColorPicker && (
                                                <div className="btp-pdf-viewer-color-picker">
                                                    <CirclePicker
                                                        colors={pickerColors}
                                                        onChangeComplete={color => {
                                                            this.onChangeDrawingColor(color.hex);
                                                            this.colorPickerToggle();
                                                        }}
                                                        color={this.state.penColor}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    <div className="divider" />
                                    {showNotes && (
                                        <Fragment>
                                            <button
                                                className={`btp-pdf-viewer-buttons toolbar-btn ${
                                                    viewer.state.currentTool === 1 ? 'active' : ''
                                                    }`}
                                                type="button"
                                                title="Highlight"
                                                data-type="highlight"
                                                onClick={viewer.changeCurrentTool}
                                                disabled={this.state.rotate % 360 !== 0}
                                            >
                                                <Highlight />
                                            </button>
                                            <div className="btp-pdf-viewer-buttons colorpicker">
                                                <ColorSelectionDropdown
                                                    title="Colour picker for highlight"
                                                    color={this.state.highlightColor}
                                                    onClick={this.colorPickerHightlightToggle.bind(
                                                        this,
                                                    )}
                                                />
                                                {this.state.showColorPickerHighlight && (
                                                    <div className="btp-pdf-viewer-color-picker">
                                                        <CirclePicker
                                                            colors={pickerHighlightColors}
                                                            onChangeComplete={color => {
                                                                // console.log('color ', e);
                                                                let rgba = String(
                                                                    'rgba(' +
                                                                    color.rgb.r +
                                                                    ',' +
                                                                    color.rgb.g +
                                                                    ',' +
                                                                    color.rgb.b +
                                                                    ',' +
                                                                    0.3,
                                                                );
                                                                this.onChangeHighlightColor(rgba);
                                                                this.colorPickerHightlightToggle();
                                                            }}
                                                            color={this.state.highlightColor}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </Fragment>
                                    )}
                                    <div className="divider" />
                                    {showNotes && (
                                        <button
                                            className={`btp-pdf-viewer-buttons toolbar-btn ${
                                                viewer.state.currentTool === 3 ? 'active' : ''
                                                }`}
                                            type="button"
                                            title="Comment"
                                            data-type="comment"
                                            onClick={viewer.changeCurrentTool}
                                            disabled={this.state.rotate % 360 !== 0}
                                        >
                                            <Notes />
                                        </button>
                                    )}
                                    {showRotation && (
                                        <button
                                            className="btp-pdf-viewer-buttons toolbar-btn"
                                            title="Rotate Clockwise"
                                            onClick={this.rotate}
                                        >
                                            <Rotate />
                                        </button>
                                    )}
                                    <div className="btp-pdf-viewer-buttons-block">
                                        <button
                                            className="btp-pdf-viewer-button-in-block toolbar-btn"
                                            title="Zoom out"
                                            onClick={this.zoomOut}
                                        >
                                            <ZoomOut />
                                        </button>
                                        <span className="btp-pdf-viewer-zoom text-muted">
                                            {this.state.scale * 100}%
                                        </span>
                                        <button
                                            className="btp-pdf-viewer-button-in-block toolbar-btn"
                                            title="Zoom in"
                                            onClick={this.zoomIn}
                                        >
                                            <ZoomIn />
                                        </button>
                                    </div>
                                    <button
                                        className="btp-pdf-viewer-buttons toolbar-btn"
                                        title="Previous page"
                                        onClick={this.prevPage}
                                    >
                                        <PagePrev />
                                    </button>
                                    <button
                                        className="btp-pdf-viewer-buttons toolbar-btn"
                                        title="Next page"
                                        onClick={this.nextPage}
                                    >
                                        <PageNext />
                                    </button>
                                    <div className="btp-pdf-viewer_sidebar-page-pager">
                                        <input
                                            ref={el => (this.pageInput = el)}
                                            className="btp-pdf-viewer_sidebar-page-input"
                                            type="text"
                                            defaultValue={this.state.page}
                                            onBlur={this.pageInputOnBlur.bind(this, viewer)}
                                            onKeyUp={this.pageInputKeyUp.bind(this, viewer)}
                                            onChange={this.onPageChange.bind(this, viewer)}
                                            onFocus={this.handleFocus}
                                        />
                                        <div className="btp-pdf-viewer_sidebar-page-total">
                                            {`/ ${viewer.state.pages || 0}`}{' '}
                                        </div>
                                    </div>
                                    {showDownload && (
                                        <button
                                            className="btp-pdf-viewer-buttons toolbar-btn"
                                            onClick={() => this.download()}
                                            title="Download a file"
                                        >
                                            <Download />
                                        </button>
                                    )}
                                    {showNotes && (
                                        <Fragment>
                                            <button
                                                onClick={viewer.clearAllAnnotations}
                                                className="btp-pdf-viewer-buttons toolbar-btn"
                                                title="Clear all annotations"
                                            >
                                                <EraseNotes />
                                            </button>
                                            <button
                                                className="btp-pdf-viewer-buttons toolbar-btn"
                                                disabled={
                                                    (historyLength > 1 &&
                                                        viewer.state.stepsBack >=
                                                        historyLength - 1) ||
                                                    historyLength === 1
                                                }
                                                onClick={viewer.undo}
                                                title="Undo"
                                            >
                                                <Undo />
                                            </button>
                                            <button
                                                className="btp-pdf-viewer-buttons toolbar-btn"
                                                disabled={viewer.state.stepsBack === 0}
                                                onClick={viewer.redo}
                                                title="Redo"
                                            >
                                                <Undo style={{ transform: 'scale(-1, 1)' }} />
                                            </button>
                                        </Fragment>
                                    )}
                                    <div className="btp-pdf-viewer-buttons fake-invisible" />
                                </div>
                                <div className="my-toolbar-right">
                                    <div>
                                        <button
                                            onClick={this.onCloseButton}
                                            className="btp-pdf-viewer-buttons close-btn toolbar-btn"
                                            title="Close viewer"
                                        >
                                            <Close />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div style={{ position: 'relative', display: 'flex', flex: 1, 'minHeight': 0 }}>
                                <div style={{ overflowX: 'scroll', overflowY: 'scroll', overflow: 'auviewerto', flex: 1, display: 'flex' }}>
                                    {viewer.renderMainView()}
                                </div>

                                <ThumbnailsListView
                                    blob={this.props.blob}
                                    onSelect={this.onSelectPage}
                                    selectedPage={this.state.page}
                                    totalPages={viewer.state.pages}
                                    annotations={viewer.state.annotations}
                                    toggle={this.toggleThumbsPanel}
                                    show={this.state.showThumbsPanel}
                                    notesIcon={<NoteYellow />}
                                    toggleIcon={<TogglerThumbs />}
                                    imageHeight={212}
                                />
                                <CommentsList
                                    toggle={this.toggleCommentPanel}
                                    onCommentClick={this.onClickComment}
                                    comments={this.getComments(viewer.state.annotations)}
                                    show={this.state.showCommentPanel}
                                    selectedId={
                                        viewer.state.selectedItem && viewer.state.selectedItem.uuid
                                    }
                                    toggleIcon={<ToggleComments />}
                                />
                            </div>
                        </Fragment>
                    );
                }}
            </PDFAnno>
        );
    }
}

FullComposition.propTypes = {
    fileName: PropTypes.string,
    blob: PropTypes.string,
    showNotes: PropTypes.bool,
    annotations: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/FullComposition.js